"use strict";

const BasicLegend = require('../lib/legend');
const BasicChart = require('./basic');
const mix = require('../lib/mix');

function legendMixin(superclass) {
	return class extends superclass {
		get legend() {
			return this._legend;
		}

		initLegend() {
			let {innerWidth, innerHeight} = this.options;
			return new BasicLegend({width: innerWidth, height: innerHeight, key: this.getX, value: this.getY});
		}

		drawLegend(selection) {
			this._legend = this.getFromOptionsOrInit('legend', this.initLegend);
			this._legend.draw({node: selection.node()});
		}

		draw(options) {
			super.draw(options);
			var legendContainer = this.canvas.append('g').classed('cm-legend', true);
			this.drawLegend(legendContainer);
		}
	};
}

module.exports = {
	LegendChart: mix(BasicChart, legendMixin),
	legendMixin: legendMixin
};


